module.exports = __webpack_public_path__ + "static/media/liefmans-fruitesse.33c527d0.jpg";